var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionLocationMarkerOutlined({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 9C19 12.6311 15.3082 17.8445 13.2867 20.4269C12.5247 21.4004 12 22 12 22C12 22 11.4753 21.4004 10.7133 20.4269C8.69185 17.8445 5 12.6311 5 9C5 5 8.13401 2 12 2C15.866 2 19 5 19 9ZM17 9C17 9.8337 16.6937 10.9664 16.0835 12.3175C15.4881 13.6358 14.6763 15.0049 13.8359 16.2656C13.1945 17.2278 12.5507 18.1054 12 18.8224C11.4493 18.1054 10.8055 17.2278 10.1641 16.2656C9.32366 15.0049 8.51187 13.6358 7.91649 12.3175C7.30633 10.9664 7 9.8337 7 9C7 6.12959 9.21339 4 12 4C14.7866 4 17 6.12959 17 9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionLocationMarkerOutlined);
export default __webpack_public_path__ + "static/media/ic_action_location_marker_outlined.f18c4c98b84be6f9617cc23f84273d3b.svg";
export { ForwardRef as ReactComponent };